import { useContext } from 'react';
import { ApprovalModalContext } from '../components/context/GenericApprovalModalProvider';

const useApprovalModal = () => {
  const { handleOpenApprovalModal, handleCloseApprovalModal } =
    useContext(ApprovalModalContext);
  return { handleOpenApprovalModal, handleCloseApprovalModal };
};

export default useApprovalModal;
